











import { Component, Vue, Prop, Watch } from "vue-property-decorator";


@Component
export default class Message extends Vue  {
  message = "";
  type = "";
  duration = 3000;
  isShow = true;
  timer: any = null;
  closed = false;
  topOffset = 20;
  onClose: Function | null = null;
  get typeClass() {
    return `message-${this.type}`;
  }
  get positionStyle() {
    return {
      top: `${this.topOffset}px`
    };
  }
  @Watch("closed")
  onClosedChange(newVal) {
    if (newVal) {
      this.isShow = false;
    }
  }
  onAfterLeave() {
    this.$destroy();
    (this.$el.parentNode as any).removeChild(this.$el);
  }
  startTimer() {
    if (this.duration > 0) {
      this.timer = setTimeout(() => {
        if (!this.closed) {
          this.close();
        }
      }, this.duration);
    }
  }
  clearTimer() {
    clearTimeout(this.timer);
  }
  keydown(e) {
    if (e.keyCode === 27) {
      // esc关闭消息
      if (!this.closed) {
        this.close();
      }
    }
  }
  close() {
    this.closed = true;
    if(typeof this.onClose === 'function') {
      this.onClose(this);
    }
  }

  mounted() {
    this.startTimer();
    document.addEventListener("keydown", this.keydown);
  }
  beforeDestroy() {
    document.removeEventListener("keydown", this.keydown);
  }
}
